export { useFullscreen } from './useFullscreen';
